/**
 * Page d'administration : création d'un utilisateur.
 */

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createUser } from "../api/adminApi";
import "./PageStyles.css";

export default function AdminUserFormPage() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    role: "user",
  });

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    if (!form.email || !form.password) {
      setError("L'email et le mot de passe sont obligatoires.");
      return;
    }
    try {
      await createUser(form);
      navigate("/admin/users");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(detail || "Erreur lors de la création.");
    }
  }

  return (
    <div className="page">
      <h2>Nouvel utilisateur</h2>
      <div className="form-card" style={{ marginTop: "1rem" }}>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Prénom</label>
              <input name="first_name" value={form.first_name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Nom</label>
              <input name="last_name" value={form.last_name} onChange={handleChange} required />
            </div>
          </div>
          <div className="form-group">
            <label>Email</label>
            <input name="email" type="email" value={form.email} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Mot de passe provisoire</label>
            <input name="password" type="text" value={form.password} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>Rôle</label>
            <select name="role" value={form.role} onChange={handleChange}>
              <option value="user">Utilisateur</option>
              <option value="admin">Admin</option>
            </select>
          </div>
          <div className="form-actions">
            <button type="submit" className="btn btn-primary">Créer</button>
            <button type="button" className="btn btn-secondary" onClick={() => navigate("/admin/users")}>
              Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
